/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeAccountProfile } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import {
  Container,
  Content,
  ContentAcessibility,
  ContentLogo,
  ContentMenu,
  Separator,
  StyledMarcaSebrae,
} from './style';

import iconMarca from '../../assets/icon-marca.svg';
import imglogo from '../../assets/tradicional.png';

function Header() {
  const { keycloak } = Sebrae.useAuth();

  /*   if (!isAuthenticated) {
      login();
    } */

  return (
    <Container id="header">
      <Content>
        <ContentAcessibility></ContentAcessibility>
        <span>‎ </span>
        {/* <BaSeLogoSebraeInverse width={40} /> */}
        <StyledMarcaSebrae
          href="https://sebrae.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          iconMarca={iconMarca}
        >
          {/* <StyledImage src={imglogoSebrae} target="_blank" alt="Logo sebrae" /> */}
          Sebrae
        </StyledMarcaSebrae>
      </Content>

      <Separator />

      <ContentMenu>
        <ContentLogo>
          <img src={imglogo} width={138} height={29} alt="Logo  empretec" />
        </ContentLogo>
        <>
          <BaSeAccountProfile
            authRealm="externo"
            authServerUrl="https://amei.sebrae.com.br/auth"
            authenticated
            avatarUrl="https://minio-cpe.sebrae.com.br/foto"
            backgroundColor="#005eb8"
            buttonCollapsed
            clientId="app-id"
            clientName="Empretec"
            cpeUrl="https://cpe-frontend.sebrae.com.br"
            foregroundColor="#ffffff"
            keycloak={keycloak}
          />
        </>
      </ContentMenu>
    </Container>
  );
}

export default Header;
